import React from "react";
import {Helmet} from "react-helmet-async";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import {Container} from "react-bootstrap";
import ServiceMatrixTableHandler from "../../components/service/MatrixTableHandler";

const MatrixPage = () => (
    <React.Fragment>
        <Helmet title="Matrix"/>
        <Container fluid className="p-0">
            <ServiceMatrixTableHandler/>
        </Container>
    </React.Fragment>
);

export default MatrixPage;
